import {
  fuseGetConnectivityConstants,
  fuseProvisioningDetailConstants,
  fuseGetConfigurationConstants,
  getRemoteRestartConstants,
} from "../_redux-constants";

export function fuseProvisioningDetailReducer(
  state = {
    provisioningDetailLoading: false,
    provisioningDetailData: null,
    provisioningDetailError: null,

    getConnectivityLoading: false,
    getConnectivityData: null,
    getConnectivityError: null,

    configurationLoading: false,
    configurationData: null,
    configurationError: null,

    remoteRestartLoading: false,
    remoteRestartData: null,
    remoteRestartError: null,
  },
  action
) {
  switch (action.type) {
    case fuseProvisioningDetailConstants.PROVISIONING_DETAIL_LOADING:
      return Object.assign({}, state, {
        provisioningDetailLoading: true,
        provisioningDetailData: null,
        provisioningDetailError: null,
      });
    case fuseProvisioningDetailConstants.PROVISIONING_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        provisioningDetailLoading: false,
        provisioningDetailData: action.data,
        provisioningDetailError: null,
      });
    case fuseProvisioningDetailConstants.PROVISIONING_DETAIL_FAILURE:
      return Object.assign({}, state, {
        provisioningDetailLoading: false,
        provisioningDetailData: null,
        provisioningDetailError: action.error,
      });

    //get remote actions connectivity
    case fuseGetConnectivityConstants.FUSE_CHECK_CONNECTIVITY_LOADING:
      return Object.assign({}, state, {
        getConnectivityLoading: true,
        getConnectivityData: null,
        getConnectivityError: null,
      });
    case fuseGetConnectivityConstants.FUSE_CHECK_CONNECTIVITY_SUCCESS:
      return Object.assign({}, state, {
        getConnectivityLoading: false,
        getConnectivityData: action.data,
        getConnectivityError: null,
      });
    case fuseGetConnectivityConstants.FUSE_CHECK_CONNECTIVITY_FAILURE:
      return Object.assign({}, state, {
        getConnectivityLoading: false,
        getConnectivityData: null,
        getConnectivityError: action.error,
      });

    //get remote actions connectivity
    case fuseGetConfigurationConstants.FUSE_CHECK_CONFIGURATION_LOADING:
      return Object.assign({}, state, {
        configurationLoading: true,
        configurationData: null,
        configurationError: null,
      });
    case fuseGetConfigurationConstants.FUSE_CHECK_CONFIGURATION_SUCCESS:
      return Object.assign({}, state, {
        configurationLoading: false,
        configurationData: action.data,
        configurationError: null,
      });
    case fuseGetConfigurationConstants.FUSE_CHECK_CONFIGURATION_FAILURE:
      return Object.assign({}, state, {
        configurationLoading: false,
        configurationData: null,
        configurationError: action.error,
      });

    //get remote actions connectivity
    case getRemoteRestartConstants.GET_REMOTE_RESTART_LOADING:
      return Object.assign({}, state, {
        remoteRestartLoading: true,
        remoteRestartData: null,
        remoteRestartError: null,
      });
    case getRemoteRestartConstants.GET_REMOTE_RESTART_SUCCESS:
      return Object.assign({}, state, {
        remoteRestartLoading: false,
        remoteRestartData: action.data,
        remoteRestartError: null,
      });
    case getRemoteRestartConstants.GET_REMOTE_RESTART_FAILURE:
      return Object.assign({}, state, {
        remoteRestartLoading: false,
        remoteRestartData: null,
        remoteRestartError: action.error,
      });

    default:
      return state;
  }
}
